import Vue from 'vue';
import axios from 'axios';

/** Keys removed on full client logout (Safe Dig header + dashboard parity). */
const HOT_SESSION_KEYS = [
  'hot-token',
  'hot-email',
  'hot-user',
  'hot-logged-user',
  'hot-user-full-name',
  'hot-user-name',
  'hot-sidebar',
  'hot-user-id',
  'hot-user-number',
  'hot-user-2fa',
  'hot-company-level',
  'hot-admin-id',
  'hot-company-name',
  'hot-company-id',
  'hot_payment_responsible',
  'redirect-path',
  'other-company-login',
  'all_user_search_data',
  'all_company_search_data',
  'all_courses_search_data',
  'all_certificate_search_data',
  'all_tutorial_video_search_data',
  'all_certificate_detail_search_data',
  'hospitality-insurance'
];

export function clearHotSession() {
  HOT_SESSION_KEYS.forEach(key => localStorage.removeItem(key));
  const http = Vue.prototype.$http;
  if (http && http.defaults && http.defaults.headers) {
    delete http.defaults.headers.authorization;
    delete http.defaults.headers['authorization'];
  }
}

/**
 * Notify backend (when a token exists), then clear client session.
 * @returns {Promise<void>}
 */
export function recordServerLogoutThenClearHotSession() {
  const token = localStorage.getItem('hot-token');
  const baseURL = process.env.VUE_APP_API_URL || 'http://localhost:8000/';
  if (token) {
    return axios
      .get(`${baseURL}user/logout_time`, {
        headers: {
          authorization: `Bearer ${token}`,
          'content-type': 'application/json'
        }
      })
      .catch(() => {})
      .then(() => {
        clearHotSession();
      });
  }
  clearHotSession();
  return Promise.resolve();
}
